import React from 'react';
import ZeventHeader from './ZeventHeader.jsx';
import StreamerList from './StreamerList.jsx';
import ZeventYearNav from './ZeventYearNav.jsx';
import { Route, Redirect } from 'react-router-dom';

class ZeventIndex extends React.Component {

	render () {
		return (
			<div className="proxima">
				<ZeventYearNav />
				<ZeventHeader />

				{/* On liste nos routes */}
				<Route exact path="/" render={() => (
					<Redirect to="/2018"/>
				)}/>
				<Route path="/:year" component={StreamerList}/>
			</div>
		);
	}
}

export default ZeventIndex;